import { Center, Modal, ModalContent, ModalOverlay, Spinner } from '@chakra-ui/react';
import { useUIContext } from '../hooks';

export const Preloader = () => {
  const { isShow } = useUIContext();

  return (
    <Modal isOpen={isShow} closeOnOverlayClick={false} onClose={() => {}} isCentered>
      <ModalOverlay />

      <ModalContent background='transparent' boxShadow='none'>
        <Center>
          <Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='blue.500' size='xl' />
        </Center>
      </ModalContent>
    </Modal>
  );
};
